import { createSelector } from 'reselect';
import { ACCOUNT_TYPE, APPLICATION_TYPE } from '../../constants/sessionStorage';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';

export const applicationSelector = (state) => state.application;

export const selectApplicationType = createSelector(
  applicationSelector,
  (state) =>
    state.SelectedApplicationTypes?.ApplicationType
      ? state.SelectedApplicationTypes
      : {
          ApplicationType: retrieveFromSessionStorage(APPLICATION_TYPE),
          AccountType: retrieveFromSessionStorage(ACCOUNT_TYPE),
        },
);

export const selectApplication = createSelector(
  applicationSelector,
  (state) => state.Application,
);

export const selectApplicationError = createSelector(
  applicationSelector,
  (state) => state.error,
);

export const selectApplicationOnboarding = createSelector(
  applicationSelector,
  (state) => state.ApplicationOnboarding,
);

export const selectSalesAssistedApplications = createSelector(
  applicationSelector,
  (state) => state.SalesAssistedApplications,
);
